import { createSelector } from '@app/utils/createSelector'
import { normalizeSafe } from '@app/utils/normalizer'

import type { ApiAnonymousParent } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'

const anonymousParentsSlice = createReduxSlice<{ [key: string]: ApiAnonymousParent }>('anonymous_parents')

export const updateAnonymousParentsSlice = (payload: unknown) =>
  anonymousParentsSlice.update(state => {
    const { anonymous_parents } = normalizeSafe<ApiAnonymousParent>(payload)
    if (!anonymous_parents) return state
    return { ...state, ...anonymous_parents }
  })

export const anonymousParentsModelsSelector = createSelector([anonymousParentsSlice.selector], parents => parents ?? {})
